import { render, staticRenderFns } from "./ThreadEditAnswer.vue?vue&type=template&id=0a1be86f&"
import script from "./ThreadEditAnswer.vue?vue&type=script&lang=js&"
export * from "./ThreadEditAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports